import textServices from 'services/text-services'
import Button from 'components/button'
import { Prize, Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { useState } from 'react'
import { ContainerError } from 'components/error-view'
import GenericError from 'components/generic-error'
import { TitleSurvey } from '../styles/styled.components'
import Options from './options'

interface IProps {
  id: number
  title: string
  prize?: Prize
  questions: Question[]
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey: (select: SurveyResponse[][], id: number) => Promise<void>
  redirect: () => void
  isOptional: boolean
}

function SurveyPolaris({
  id,
  title,
  questions,
  handleSubmit,
  updatePolarisSurvey,
  prize
}:
  IProps) {
  const [selected, setSelected] = useState<Record<string, number[]>>({})
  const [textValue, setTextValue] = useState<Record<string, string>>({})
  const [alertPrize, setAlertPrize] = useState(!!prize)

  const validateAmountAnwsers = (select: any) => {
    const selectedFilter = select?.filter((item, index) => {
      let amountAnswers = questions[index]?.type === 'Normal' ? questions[index]?.amountAwnsers : 1
      if (questions[index]?.type === 'Normal') {
        const anwser = questions[index]?.options.filter(
          (o) => (item as any)?.optionIds.find((x) => x === o.optionId) === o.optionId
        )
        if (anwser.some((o) => o.demandSpaceId === 0)) {
          amountAnswers = 0
        }
      }
      return (item as any)?.optionIds.length < amountAnswers
    })
    return selectedFilter?.length > 0
  }

  const onSubmit = async () => {
    const select = []
    for (const key in selected) {
      select.push({ questionId: parseInt(key), optionIds: selected[key], textValue: textValue[key] !== '' ? textValue[key] : null })
    }
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: textServices.findByText('survey/button', 'ACTUALIZAR'),
      section: `survey`
    })
    if (validateAmountAnwsers(select)) {
      dlTrackEvent('error', {
        error_type: 'survey',
        error_code: 9999,
        error_message: 'Por favor, responde todas las preguntas',
        section: `survey`
      })
      return alert('Por favor, responde todas las preguntas')
    }
    await updatePolarisSurvey(select as any as SurveyResponse[][], id)
  }

  if (THEME === 'dosequis' && alertPrize) {
    return (
      <ContainerError handleMenu={() => setAlertPrize(null)}>
        <GenericError
          error={textServices.findByText('survey/alertPrize/title', { es: title, en: '1° CHALLENGE' })}
          description={textServices.findByText('survey/alertPrize/description',
            {
              es:
                <>
                  Estás a punto de participar:<br />
                  <b>{prize?.title}</b><br /><br />
                  ¿Seguro que quieres empezar a jugar?<br />
                  Una vez que des clic no hay vuelta atrás.
                </>,
              en:
                <>
                  You are about to participate:<br />
                  <b>{prize?.title}</b><br /><br />
                  Are you sure you want to start playing?<br />
                  once you click there is no turning back.
                </>,
            }
          )}
          buttonText={textServices.findByText('survey/alertPrize/button', { es: 'SI, CLARO', en: 'YES, OF COURSE' })}
          onRetry={() => setAlertPrize(null)}
        />
      </ContainerError>
    )
  }

  const hasNonEmptyValues = (): boolean => {
    return Object.values(selected).some(value => {
      if (Array.isArray(value)) return value.length > 0;
      return true;
    });
  };

  return (
    <div className={`w-full survey-container ${id === 14 ? 'survey-special' : ''}`}>
      <div className='flex flex-col justify-center items-center pt-4'>
        <TitleSurvey className="font-black text-4xl text-center title-survey">
          {
            id === 20 ? 'Paso 1' : 'Encuesta'
          }
        </TitleSurvey>
        <TitleSurvey className="font-black text-4xl text-center title-survey">{title}</TitleSurvey>
        {
          (id === 19) && (
            <div className='pt-2 px-4 text-center'>
              <p className='text big'><b>Fecha:</b> 06 de noviembre</p>
              <p className='text big'><b>Ciudad:</b> Guadalajara</p>
              <p className='text big pt-2'>Confirma tu asistencia para asegurar tu lugar. Recuerda que tu Heineken ID será tu pase de entrada.</p>
            </div>
          )
        }
        {
          (id === 14) && (
            <div className='pt-2 px-4 text-center'>
              <p className='text big'>Calificar tu experiencia y participa por increíbles premios que tiene Heineken para ti.</p>
            </div>
          )
        }
        {
          (id === 20) && (
            <div className='pt-2 px-4 text-center'>
              <p className='text big'>Queremos conocerte mejor, ayúdanos contestando 2 preguntas.</p>
            </div>
          )
        }
      </div>
      <div className="flex flex-col items-center gap-2 p-4 md:mt-10 container-survey">
        {questions?.map(({ questionId, question, subtitle, options, type, amountAwnsers, columns }, index) => (
          <Options
            surveyId={id}
            onChange={(data, select, value) => {
              setTextValue((state) => ({ ...state, [data]: value }))
              setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))
            }}
            options={options}
            question={question}
            subtitle={subtitle}
            questionId={questionId}
            type={type}
            key={index}
            amountAnswers={amountAwnsers}
            columns={columns}
          />
        ))}
        <Button onClick={() => handleSubmit(onSubmit)} className='w-full' disabled={!hasNonEmptyValues()} style={{ opacity: `${hasNonEmptyValues() ? '1' : '0.5'}` }}>
          {textServices.findByText('survey/button', { es: 'ACTUALIZAR', en: 'UPDATE' })}
        </Button>
      </div>
    </div>
  )
}

export default SurveyPolaris
